import { useQuery } from "@tanstack/react-query";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import { oneOnboardingApi } from "libs/api";
import isEmpty from "lodash/isEmpty";
import { useParams } from "router";
import { pictureTypeMapper } from "./photos/constants";

export const usePropertyDataApi = () => {
    const { lang, propertyId } = useParams("/:lang/list-my-property/onboard/:propertyId/basics");

    const { data, isError, refetch, isFetching } = useQuery({
        queryKey: [TanstackQueryKey.GetPropertyData, lang, propertyId],
        queryFn: () =>
            oneOnboardingApi.getPropertyData(lang, Number(propertyId)).then((res) => {
                let propertyData = res.data;

                // if property description is empty, then force to null
                if (isEmpty(propertyData.propertyDescription)) propertyData.propertyDescription = undefined;

                // if all photos does not have MainPhoto type, then make the first one become one
                if (
                    propertyData.photos.length > 0 &&
                    propertyData.photos.every((photo) => photo.pictureTypeId !== pictureTypeMapper.mainPhoto)
                )
                    propertyData.photos[0].pictureTypeId = pictureTypeMapper.mainPhoto;

                // weekly, monthly promotion if backend send as null means no value, then default to undefined
                if (propertyData.weeklyDiscount === -1) propertyData.weeklyDiscount = undefined;
                if (propertyData.monthlyDiscount === -1) propertyData.monthlyDiscount = undefined;

                if (propertyData.nightlyRate === 0) propertyData.nightlyRate = undefined;

                return propertyData;
            }),
    });

    return {
        data,
        isLoading: isFetching,
        isError,
        refetch,
    };
};
